import { designTokens as t } from "../design-tokens.js";
function f(o, i, e) {
  let n = t.fontWeight[o];
  i && i !== "italic" && (n = t.fontWeight[i]);
  let r = `var(${t.lineHeight[o].cssCustomProperty})`;
  return e && (r = "100%"), `
    font-family: var(${t.fontFamily.sans.cssCustomProperty});
    font-size: var(${t.fontSize[o].cssCustomProperty});
    font-style: ${i === "italic" ? "italic" : "normal"};
    font-weight: var(${n.cssCustomProperty});
    line-height: ${r};
  `;
}
export {
  f as typography
};
